import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "overflow-y-auto overflow-x-hidden pa-5 bg-primary" }
const _hoisted_2 = { class: "d-inline-block" }
const _hoisted_3 = { class: "d-inline-block" }
const _hoisted_4 = { class: "ma-0" }
const _hoisted_5 = { class: "ma-0" }
const _hoisted_6 = { class: "ma-0" }
const _hoisted_7 = { class: "ma-0" }
const _hoisted_8 = { class: "d-block" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("button", null, "Options", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h1", null, "Times:", -1)
const _hoisted_11 = { class: "fs-2" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "d-inline-block me-3 timeListText" }, "|", -1)
const _hoisted_14 = { class: "d-inline-block me-3 timeListText" }

import { ref, toRaw, watch } from "vue";
import formatNormal from "@/js/timeFormat";
import TimeChart from "@/components/TimeChart.vue";
import { type Time, Average, Stats } from "@/js/types";

export default /*#__PURE__*/_defineComponent({
  __name: 'TimeList',
  props: ["time", "username", "editingOptions", "updateChart", "showChart", "guestModeChanged", "makeChangeToTime", "updateStats"],
  emits: ["changeOptions", "modify-time", "stopModyfiyngTime", "clearModifyArray", "timeDeleted", "timeListChanged"],
  setup(__props, { emit: __emit }) {

const props = __props;
const emit = __emit;

//* vars
const jscookie = require("js-cookie");
let timeArray = ref<Time[]>([]);
let timeArrayAvgs = ref<
    {
        str: string;
        num: number;
    }[]
>([
    {
        str: "0.00",
        num: 0,
    },
    {
        str: "0.00",
        num: 0,
    },
    {
        str: "0.00",
        num: 0,
    },
    {
        str: "0.00",
        num: 0,
    },
    //* four empty averages to offset the first 5 solves
]);
let pbTime = ref<Time>({
    id: 0,
    str: "0.00",
    num: 0,
    added2: false,
    addedDnf: false,
    scramble: "",
    date: Number(new Date()),
});
let pbAo5 = ref<{
    str: string;
    num: number;
}>({
    str: "0.00",
    num: 0,
});
let changeScramble: number = 0;

let statsModeInfo = ref<string>("");
if (jscookie.get("statsMode") == -1) {
    statsModeInfo.value = "(all)";
} else if (jscookie.get("statsMode") == 1) {
    statsModeInfo.value = "(today)";
}
let currStats = ref<Stats>([0, "0.00", "0.00", "0.00"]);

//* communication with database
async function fetchData(method: string, body?: object) {
    if (jscookie.get("isGuest") === "1") return;
    try {
        const fetched = await fetch(process.env.VUE_APP_DB_API_URL, {
            method: method,
            headers: {
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*",
            },
            body: JSON.stringify(body),
        });
        const data = await fetched.json();
        return data;
    } catch (e) {
        console.warn(`Error while fetching data: ${e}`);
        modifyTime("remove", timeArray.value[timeArray.value.length - 1]);
        return false;
    }
}
async function getData() {
    fetchData("get").then((e) => {
        if (jscookie.get("isGuest") === "1") return;
        clearCookies();
        e.forEach((i: any) => {
            if (i.username == props.username) {
                let newTime = {
                    id: i.id,
                    str: i.str,
                    num: i.num,
                    added2: i.added2,
                    addedDnf: i.addedDnf,
                    scramble: i.scramble,
                    date: Number(i.date),
                };
                timeArray.value.push(newTime);
            }
        });
    });
}
//* adding times
function postData(body: any) {
    body.username = props.username;
    fetchData("post", body);
}
//* modifying times
function putData(body: any) {
    body.username = props.username;
    fetchData("put", body);
}
//* deleting times
function delData(body: any) {
    body.username = props.username;
    fetchData("delete", body);
}

//* push the time to timeArray
function addTime(time: Time) {
    //* fix ids (i dont know how to do it in a better way)
    try {
        time.id = timeArray.value[timeArray.value.length - 1].id + 1;
    } catch (e) {
        time.id = 0;
    }
    timeArray.value.push(time);
    postData(time);
}

//* modify the time to add +2, dnf or remove it
function modifyTime(action: "plus2" | "dnf" | "remove", time: Time) {
    //* add +2 to time
    if (action == "plus2") {
        timeArray.value.forEach((e) => {
            if (e.id == time.id && e.num == time.num && e.str == time.str && !e.added2) {
                if (e.addedDnf) {
                    e.addedDnf = !e.addedDnf;
                    e.str = formatNormal(e.num.toString());
                }
                e.added2 = !e.added2;
                e.num += 200;
                e.str = formatNormal(e.num.toString()) + "+";
            } else if (e.id == time.id && e.num == time.num && e.str == time.str && e.added2) {
                e.added2 = !e.added2;
                e.num -= 200;
                e.str = formatNormal(e.num.toString());
            }
        });
        putData(time);
    } else if (action == "dnf") {
        //* change time to dnf
        timeArray.value.forEach((e) => {
            if (e.id == time.id && e.num == time.num && e.str == time.str && !e.addedDnf) {
                if (e.added2) {
                    e.added2 = !e.added2;
                    e.num -= 200;
                    e.str = formatNormal(e.num.toString());
                }
                e.addedDnf = !e.addedDnf;
                e.str = `DNF(${e.str})`;
            } else if (e.id == time.id && e.num == time.num && e.str == time.str && e.addedDnf) {
                e.addedDnf = !e.addedDnf;
                e.str = formatNormal(e.num.toString());
            }
        });
        putData(time);
    } else if (action == "remove") {
        //* remove the time
        delData(time);
        timeArray.value.forEach((e) => {
            timeArray.value = timeArray.value.filter((e) => {
                if (e.id == time.id && e.str == time.str && e.num == time.num && e.added2 == time.added2 && e.addedDnf == time.addedDnf && e.scramble == time.scramble && e.date == time.date) {
                    return false;
                }
                return true;
            });
        });
    }

    //* defocus the buttons after clicking to fix the bug of deleting times instead of adding them
    let buttons = Array.from(document.getElementsByClassName("timeBtn") as HTMLCollectionOf<HTMLElement>);
    for (let e of buttons) {
        e.blur();
    }
}

//* calculate mean of session
function meanOfArr(array: Time[]): string {
    if (array.length > 0) {
        let sumOfTimes = array.reduce((acc, e) => {
            return acc + e.num;
        }, 0);
        let meanNum = Math.trunc(sumOfTimes / array.length);
        let meanStr: string = formatNormal(meanNum.toString());
        return meanStr;
    } else {
        return "0.00";
    }
}

//* track props to add to timeArray
watch(
    () => props.time,
    (time) => {
        addTime(time);
    },
);

//* track timeArray to have access in Timer.vue
watch(
    () => timeArray,
    () => {
        jscookie.set("timeArray", JSON.stringify(timeArray.value));
    },
);

//* watch for an timeArray change to save it and update pb
watch(
    timeArray,
    (timeArray) => {
        //* pb change
        let timeArrayCopy = timeArray;
        timeArrayCopy = timeArrayCopy.filter((e) => !e.addedDnf);
        if (timeArrayCopy.length > 0) {
            pbTime.value = timeArrayCopy.sort((a: Time, b: Time) => {
                if (a.num > b.num && !a.addedDnf) {
                    return 1;
                } else if (a.num < b.num && !b.addedDnf) {
                    return -1;
                } else {
                    return 0;
                }
            })[0];
        } else {
            pbTime.value = {
                id: 0,
                str: "0.00",
                num: 0,
                added2: false,
                addedDnf: false,
                scramble: "",
                date: Number(new Date()),
            };
        }

        //* calculate avg of 5
        timeArrayAvgs.value = [
            {
                str: "0.00",
                num: 0,
            },
            {
                str: "0.00",
                num: 0,
            },
            {
                str: "0.00",
                num: 0,
            },
            {
                str: "0.00",
                num: 0,
            },
            // four empty averages to offset the first 5 solves
        ];

        timeArrayAvgs.value.push(...calcAvgs(timeArray));

        currStats.value = getStats(timeArray);

        //* cookies change
        jscookie.set("timeArray", JSON.stringify(timeArray), {
            expires: 365 * 10,
        });
    },
    { deep: true },
);

const getConsecutiveArrays = <T, _>(arr: T[], size: number): T[][] => (size > arr.length ? [] : arr.slice(size - 1).map((_, i) => arr.slice(i, size + i)));

//* function to calculate avg of 5
function calcAvgs(tempTimeArr: Time[]): Average[] {
    let timeArrayCopy: Time[] = [...toRaw(tempTimeArr)];

    let allArrays = getConsecutiveArrays(timeArrayCopy, 5);

    let allAvgs: Average[] = [];

    allArrays.forEach((array) => {
        allAvgs.push(calcAvg(array));
    });

    return allAvgs;
}

function calcAvg(array: Time[]): Average {
    let finalAvg: Average = {
        str: "0.00",
        num: 0,
    };

    array.sort((a, b) => {
        if (a.addedDnf) {
            return 1;
        }
        if (b.addedDnf) {
            return -1;
        }

        if (a.num > b.num) {
            return 1;
        } else if (a.num < b.num) {
            return -1;
        }
        return 0;
    });

    array.shift();
    array.pop();

    let dnfAvg: boolean = false;

    array.forEach((e) => {
        if (e.addedDnf) {
            dnfAvg = true;
        }
    });

    if (dnfAvg) {
        finalAvg = {
            str: "DNF",
            num: -1,
        };
    } else {
        let sumOfTimes = array.reduce((acc, e) => {
            return acc + e.num;
        }, 0);

        sumOfTimes = Math.round(sumOfTimes / 3);
        finalAvg = {
            str: formatNormal(sumOfTimes.toString()),
            num: sumOfTimes,
        };
    }

    return finalAvg;
}

function getStats(tempTimeArr: Time[]): Stats {
    if (tempTimeArr.length == 0) {
        currStats.value = [0, "0.00", "0.00", "0.00"];
        return currStats.value;
    }

    if (jscookie.get("statsMode") == "1") {
        tempTimeArr = tempTimeArr.filter((e) => {
            return new Date(e.date).toDateString() == new Date().toDateString();
        });
    }

    let pbTimeStats = tempTimeArr.toSorted((a, b) => {
        if(a.addedDnf){
            return 1;
        } else if(b.addedDnf){
            return -1;
        }
        
        if (a.num > b.num) {
            return 1;
        } else if (a.num < b.num) {
            return -1;
        }
        return 0;
    })[0];

    let pbAo5Stats: Average = {
        str: "0.00",
        num: 0,
    };

    if (tempTimeArr.length >= 5) {
        pbAo5Stats = calcAvgs(tempTimeArr)
            .filter((a) => a.num != -1)
            .sort((a, b) => {
                if (a.num > b.num) {
                    return 1;
                } else if (a.num < b.num) {
                    return -1;
                }
                return 0;
            })[0];
    }

    return [tempTimeArr.length, pbTimeStats.str, pbAo5Stats.str, meanOfArr(tempTimeArr)];
}

watch(
    () => props.updateStats,
    () => {
        if (jscookie.get("statsMode") == -1) {
            statsModeInfo.value = "(all)";
        } else if (jscookie.get("statsMode") == 1) {
            statsModeInfo.value = "(today)";
        }

        currStats.value = getStats(timeArray.value);
    },
);

watch(
    timeArrayAvgs,
    (timeArrayAvgs) => {
        //* update pbao5
        if (timeArrayAvgs.length > 0) {
            let newTimeArrayAvgs = timeArrayAvgs.filter((e) => {
                if (e.num < 1) {
                    return false;
                }
                return true;
            });
            if (newTimeArrayAvgs.length > 0) {
                newTimeArrayAvgs.sort(
                    (
                        a: {
                            str: string;
                            num: number;
                        },
                        b: {
                            str: string;
                            num: number;
                        },
                    ) => {
                        if (a.num > b.num) {
                            return 1;
                        } else if (a.num < b.num) {
                            return -1;
                        } else {
                            return 0;
                        }
                    },
                );
                pbAo5.value = newTimeArrayAvgs[0];
            } else {
                pbAo5.value = {
                    str: "0.00",
                    num: 0,
                };
            }
        } else {
            pbAo5.value = {
                str: "0.00",
                num: 0,
            };
        }

        //* cookies change
        jscookie.set("timeArrayAvgs", JSON.stringify(timeArrayAvgs), {
            expires: 365 * 10,
        });
    },
    { deep: true },
);

//* restore values from cookies
if (jscookie.get("timeArray")) {
    timeArray.value = JSON.parse(jscookie.get("timeArray"));
}
if (jscookie.get("timeArrayAvgs")) {
    timeArrayAvgs.value = JSON.parse(jscookie.get("timeArrayAvgs"));
}

function clearCookies() {
    timeArray.value = [];
    timeArrayAvgs.value = [];
    emit("timeDeleted");
    jscookie.remove("timeArray");
    jscookie.remove("timeArrayAvgs");
}

watch(
    () => props.username,
    () => {
        if (jscookie.get("isGuest") === "1") return;
        clearCookies();
        getData();
    },
);

watch(
    () => props.guestModeChanged,
    () => {
        if (jscookie.get("isGuest") === "1") return;
        clearCookies();
        getData();
    },
);

if (jscookie.get("isGuest") !== "1") {
    clearCookies();
    getData();
}

//* shortcuts to add +2 and DNF to the last solve
document.body.addEventListener("keydown", (event) => {
    if (timeArray.value.length < 1) return;
    if (event.key == "2" && event.ctrlKey) {
        event.preventDefault();
        modifyTime("plus2", timeArray.value[timeArray.value.length - 1]);
    }
    if (event.key == "3" && event.ctrlKey) {
        event.preventDefault();
        modifyTime("dnf", timeArray.value[timeArray.value.length - 1]);
    }
});

watch(
    () => props.makeChangeToTime,
    (value) => {
        if (value) {
            modifyTime(value[0], value[1]);
            emit("stopModyfiyngTime");
            emit("clearModifyArray");
        }
    },
);

return (_ctx: any,_cache: any) => {
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createVNode(TimeChart, {
        timeList: _unref(timeArray),
        "update-chart-num": props.updateChart
      }, null, 8, ["timeList", "update-chart-num"]), [
        [_vShow, props.showChart]
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("h1", null, "Stats " + _toDisplayString(_unref(statsModeInfo)) + ":", 1),
      _createElementVNode("h2", _hoisted_4, "Solves: " + _toDisplayString(_unref(currStats)[0]), 1),
      _createElementVNode("h2", _hoisted_5, "PB single: " + _toDisplayString(_unref(currStats)[1]), 1),
      _createElementVNode("h2", _hoisted_6, "PB ao5: " + _toDisplayString(_unref(currStats)[2]), 1),
      _createElementVNode("h2", _hoisted_7, "Mean: " + _toDisplayString(_unref(currStats)[3]), 1)
    ]),
    _createVNode(_component_v_divider, {
      class: "my-3",
      thickness: 3,
      length: "100%"
    }),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_v_btn, {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('changeOptions', true))),
        disabled: props.editingOptions,
        class: "d-inline-block",
        color: "background"
      }, {
        default: _withCtx(() => [
          _hoisted_9
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    _createVNode(_component_v_divider, {
      class: "my-3",
      thickness: 3,
      length: "100%"
    }),
    _hoisted_10,
    _createElementVNode("ul", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(timeArray).toReversed(), (time) => {
        return (_openBlock(), _createElementBlock("li", _hoisted_11, [
          _createElementVNode("p", {
            class: "d-inline-block me-3 timeListText cursor-pointer timeListTextHover",
            onClick: ($event: any) => (emit('modify-time', time))
          }, _toDisplayString(time.str), 9, _hoisted_12),
          _hoisted_13,
          _createElementVNode("p", _hoisted_14, " a05: " + _toDisplayString(_unref(timeArrayAvgs).length >= _unref(timeArray).indexOf(time) && _unref(timeArrayAvgs)[_unref(timeArray).indexOf(time)]?.str ? _unref(timeArrayAvgs)[_unref(timeArray).indexOf(time)].str : "0.00"), 1)
        ]))
      }), 256))
    ])
  ]))
}
}

})